export default "__VITE_ASSET__CzC_0qZY__"